import * as focusTrap from 'focus-trap';

export default {
  init() {
    // This somehow doesn't work on prod.
    return false;

    const currentlyShownCookieNotice = document.querySelector( '.cmplz-cookiebanner' );
    const toggleManageCookieConsent = document.querySelector( '.cmplz-manage-consent' );
    const closeCookieNotice = document.querySelector( '.cmplz-close' );

    if (!currentlyShownCookieNotice || !toggleManageCookieConsent || !closeCookieNotice) {
      return;
    }

    let trap = focusTrap.createFocusTrap( currentlyShownCookieNotice, {
      // Fallback focus is needed because without it the library will for whatever reason not find any focusable elements.
      fallbackFocus: closeCookieNotice,
    } );

    // We need to trigger the focus trap on a few occasions...
    // Occasion 1: When the cookie banner is loaded and shown.
    document.addEventListener( 'cmplz_cookie_banner_data', () => {
      trap.activate();
    } );

    // Occasion 2: When the cookie banner is toggled.
    toggleManageCookieConsent.addEventListener( 'click', event => {
      trap.activate();
    } );

    // But we also need to deactivate the focus trap when the cookie banner is closed.
    // Occasion 1: When the status changes, this is a click on either 'yes' or 'no'.
    document.addEventListener( 'cmplz_status_change', () => {
      trap.deactivate();
    } );

    // Occasion 2: When the cookie banner is closed.
    closeCookieNotice.addEventListener( 'click', () => {
      trap.deactivate();
    } );

    // Occasion 3: When the user revokes consent, this is a click on 'no' after 'yes' was clicked before.
    document.addEventListener( 'cmplz_revoke', () => {
      trap.deactivate();
    } );
  },
};
